import React from 'react'

export const FareTableStateContext = React.createContext()
export const FareTableDispatchContext = React.createContext()
export const FareDataForTopContext = React.createContext();